import { render, staticRenderFns } from "./Outsiders.vue?vue&type=template&id=438b7be9"
import script from "./Outsiders.vue?vue&type=script&lang=js"
export * from "./Outsiders.vue?vue&type=script&lang=js"
import style0 from "./Outsiders.vue?vue&type=style&index=0&id=438b7be9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports